import React, {useState, useEffect, useMemo} from 'react'
import './ContainerViewer.css';
import { useCookies } from 'react-cookie';
import Swal from 'sweetalert2'
import GetReCaptchaToken from '../reCAPTCHA.js';
import Select from 'react-select';

const ContainerCard = React.memo((cci) => {
    const container = cci.container;

    const [quotable, setQuotable] = useState((cci?.Quotable ?? false) && cci.ID != undefined);
    const [cookies, setCookie] = useCookies([container.containerNo]);
    const [disabled, setDisabled] = useState({buy: cookies.hasOwnProperty(container.containerNo + "buy") || false, hire: cookies.hasOwnProperty(container.containerNo + "hire") || false});

    async function sendQuoteRequest(type, cID, uID) {
        let token = await GetReCaptchaToken();
        
        const data = {
            quoteId: uID,
            containerId: cID,
            quoteType: type,
            token: token
        }
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };
        fetch('/AddToQuote', requestOptions).then(res=> {
            return res.json();
        }).then(res=> {
            if(res.successful){
                setCookie(container.containerNo + type, true, {maxAge: 86400, sameSite: true});

                let obj = {...disabled, [type]: true};
                setDisabled(obj);
                Swal.fire(
                    'Success.',
                    res.message,
                    'success'
                )
            }
            else {
                Swal.fire(
                    'Error',
                    res.message,
                    'error'
                )
            }
        })
    }

    async function requestQuote(type, Id) {
        if(!disabled[type]){
            await sendQuoteRequest(type, Id, cci.ID)
        }else {
            Swal.fire(
                'Error',
                "This container is already added to your quote.",
                'error'
            )
        }
    }

    return (
        <div className="ContainerCard center">
            {
                container.photoLink !== null ? <img src={container.photoLink} className={`${container.isSaleable !== 1 && 'unavailable'}`} alt={`${container.gradeName} - ${container.colourName}`} /> : <img src="/assets/img/no-image.webp" alt={`${container.gradeName} - ${container.colourName}`} />
            }
            <div className="d-flex space-between align-center w-90">
                <h3>{container.containerNo}</h3>
                <div className={`availability ${container.isSaleable !== 1 && 'unavailable'}`}>{container.isSaleable === 1 ? "Available" : "Unavailable"}</div>
            </div>
            <div className="col d-flex justify-left w-90">
                <h4 className='no-block-end no-block-start'>{container.description}</h4>
                <h4 className='no-block-end no-block-start'><span className='bold'>ISO:</span> {container.ISOName}</h4>
                <h4 className='no-block-end no-block-start'><span className='bold'>Grade:</span> {container.gradeId}</h4>
                <h4 className='no-block-end no-block-start'><span className='bold'>Colour:</span> {container.colourName}</h4>
                <h4 className='no-block-end no-block-start'><span className='bold'>Price:</span> {container.salePriceEx}*</h4>
            </div><br />
            {(quotable === true ? 
            <div className='bg-light ptb-1'>
                <div className="d-flex col">
                    <div className="v-spacer"></div>
                    <div className="d-flex w-90 text-center justify-center">
                        <div className={`Button center text-center ${disabled.hire && 'disabled'}`} onClick={()=> requestQuote(1, container.containerId)}>{container.isSaleable !== 1 ? "Request similar containers" : "Add to quote"}</div>
                        <div className="d-flex col justify-center align-center text-center">
                        </div>
                        {
                            /*
                            <div className="d-flex col flex-4 justify-center">
                                <div className={`Button bg-main w-100 center ${disabled.buy && 'disabled'}`} onClick={()=> requestQuote(2, container.containerId)}>Hire</div>
                            </div>
                            */
                        }
                    </div>
                </div>
            </div>
            :
            <></>
            )}
        </div>
    )
});

export default function ContainerViewer(props) {

    const [loaded, setLoaded] = useState(false);

    const [containers, setContainers] = useState([]);
    const [filteredContainers, setFilteredContainers] = useState([]);

    const [ISOs, SetISOs] = useState([]);
    const [Lengths, SetLengths] = useState([]);
    const [Heights, SetHeights] = useState([]);
    const [Grades, SetGrades] = useState([]);
    const [Colours, SetColours] = useState([]);
    const [Availabilities, SetAvailabilities] = useState([]);

    const [containerSearch, setContainerSearch] = useState();
    const [filterISO, setFilterISO] = useState([]);
    const [filterLength, setFilterLength] = useState([]);
    const [filterHeight, setFilterHeight] = useState([]);
    const [filterGrade, setFilterGrade] = useState([]);
    const [filterColour, setFilterColour] = useState([]);
    const [filterAvailable, setFilterAvailable] = useState([]);
    
    function filterValues() {
        let outContainers = [...containers];

        //Remove unavailable containers if we are in quoting mode.
        if (props.Quotable === true)
        {
            outContainers = outContainers.filter(x => x.isSaleable == true);
        }
        
        //Container number search.
        if(containerSearch !== undefined && containerSearch !== "" && containerSearch !== null) {
            let searh = containerSearch.toUpperCase();
            outContainers = outContainers.filter(x => x.containerNo.toUpperCase().indexOf(searh) > -1);
        }

        //ISO Filter.
        if (filterISO.length > 0)
        {
            outContainers = outContainers.filter(x => filterISO.some(y => x.ISOId == y.value));
        }

        //Length Filter.
        if (filterLength.length > 0)
        {
            outContainers = outContainers.filter(x => filterLength.some(y => x.length_id == y.value));
        }

        //Height Filter.
        if (filterHeight.length > 0)
        {
            outContainers = outContainers.filter(x => filterHeight.some(y => x.height_id == y.value));
        }

        //Grade Filter.
        if (filterGrade.length > 0)
        {
            outContainers = outContainers.filter(x => filterGrade.some(y => x.gradeId == y.value));
        }

        //Colour Filter.
        if (filterColour.length > 0)
        {
            outContainers = outContainers.filter(x => filterColour.some(y => x.colourId == y.value));
        }

        //Availability Filter.
        if (filterAvailable.length > 0)
        {
            outContainers = outContainers.filter(x => filterAvailable.some(y => x.isSaleable == y.value));
        }

        return outContainers;
    }

    useEffect(async ()=> {
        try
        {
            let token = await GetReCaptchaToken();
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ depotGuid: props.GUID, token: token })
            };
            let response = await fetch('/DepotContainers', requestOptions);
            let json = await response.json();
            setContainers(json);

            let iso_map = Map.groupBy(json, (e, i) => e.ISOId);
            let isos = [];
            for (let iso_id of iso_map.keys())
            {
                let elem = iso_map.get(iso_id)[0];
                isos.push({ value: elem.ISOId, label: elem.ISOName });
            }
            SetISOs(isos);

            let length_map = Map.groupBy(json, (e, i) => e.length_id);
            let lengths = [];
            for (let length_id of length_map.keys())
            {
                let elem = length_map.get(length_id)[0];
                lengths.push({ value: elem.length_id, label: elem.length_name });
            }
            SetLengths(lengths);

            let height_map = Map.groupBy(json, (e, i) => e.height_id);
            let heights = [];
            for (let height_id of height_map.keys())
            {
                let elem = height_map.get(height_id)[0];
                heights.push({ value: elem.height_id, label: elem.height_name });
            }
            SetHeights(heights);

            let grade_map = Map.groupBy(json, (e, i) => e.gradeId);
            let grades = [];
            for (let gradeId of grade_map.keys())
            {
                let elem = grade_map.get(gradeId)[0];
                grades.push({ value: elem.gradeId, label: elem.grade_short });
            }
            SetGrades(grades);

            let colour_map = Map.groupBy(json, (e, i) => e.colourId);
            let colours = [];
            for (let colourId of colour_map.keys())
            {
                let elem = colour_map.get(colourId)[0];
                colours.push({ value: elem.colourId, label: elem.colourName });
            }
            SetColours(colours);

            let available_map = Map.groupBy(json, (e, i) => e.isSaleable);
            let availables = [];
            for (let isSaleable of available_map.keys())
            {
                let elem = available_map.get(isSaleable)[0];
                availables.push({ value: elem.isSaleable, label: elem.isSaleable == true ? "Available" : "Not Available" });
            }
            SetAvailabilities(availables);
        }
        finally
        {
            setLoaded(true);
        }
    }, []);

    useEffect(() => {
        setFilteredContainers(filterValues());
    }, [containers, containerSearch, filterISO, filterLength, filterHeight, filterGrade, filterColour, filterAvailable]);

    return (
        <div className='ContainerViewer w-100'>
            <div className="w-90 text-center col align-center justify-center">
                <div className='filters search-filter'>
                    <input className='FilterInput' type="text" placeholder='Search Container Number...' onChange={e=>setContainerSearch(e.target.value)} value={containerSearch}/>
                </div>
                <div className='filters'>
                    <Select
                        classNamePrefix="FilterSelect"
                        isMulti
                        isClearable={true}
                        isSearchable={true}
                        name="ISO"
                        options={ISOs}
                        onChange={(x) => setFilterISO(x)}
                        value={filterISO}
                        placeholder="Filter By ISO..."
                    />
                    <Select
                        classNamePrefix="FilterSelect"
                        isMulti
                        isClearable={true}
                        isSearchable={true}
                        name="Length"
                        options={Lengths}
                        onChange={(x) => setFilterLength(x)}
                        value={filterLength}
                        placeholder="Filter By Length..."
                    />
                    <Select
                        classNamePrefix="FilterSelect"
                        isMulti
                        isClearable={true}
                        isSearchable={true}
                        name="Height"
                        options={Heights}
                        onChange={(x) => setFilterHeight(x)}
                        value={filterHeight}
                        placeholder="Filter By Height..."
                    />
                    <Select
                        classNamePrefix="FilterSelect"
                        isMulti
                        isClearable={true}
                        isSearchable={true}
                        name="Rank"
                        options={Grades}
                        onChange={(x) => setFilterGrade(x)}
                        value={filterGrade}
                        placeholder="Filter By Rank..."
                    />
                    <Select
                        classNamePrefix="FilterSelect"
                        isMulti
                        isClearable={true}
                        isSearchable={true}
                        name="Colour"
                        options={Colours}
                        onChange={(x) => setFilterColour(x)}
                        value={filterColour}
                        placeholder="Filter By Colour..."
                    />
                    <Select
                        classNamePrefix="FilterSelect"
                        isMulti
                        isClearable={true}
                        isSearchable={true}
                        name="Availability"
                        options={Availabilities}
                        onChange={(x) => setFilterAvailable(x)}
                        value={filterAvailable}
                        placeholder="Filter By Availability..."
                    />
                </div>
                {
                    loaded === true ?
                    filteredContainers.map((container) => {
                        return (
                            <ContainerCard key={container.containerNo} container={container} ID={props.ID} Quotable={props.Quotable}/>
                        )
                    })
                    :
                    <p className='loading'>Loading...</p>
                }
            </div>
        </div>
    )
}
